import React from 'react'
import { InformationPanel, ReceiptCard, styled } from '~/app/components'
import { InformationFormat } from '~/app/components/order-list/details/InformationPanel'

/**
 * CancelCard component
 * author: soojin.oh
 */

// type definitions
type CancelCardProps = {
  information: InformationFormat[]
}

// styled components
const CancelReceiptCard = styled(props => <ReceiptCard {...props} />)`
  margin: 2rem 0;
  padding-top: 1.2rem;

  :first-of-type {
    margin: 0;
  }

  :last-of-type {
    margin-bottom: 0;
  }
`

// CancelCard component
const CancelCard: React.FC<CancelCardProps> = function ({ information }) {
  return (
    <CancelReceiptCard>
      <InformationPanel information={information} />
    </CancelReceiptCard>
  )
}

export default CancelCard
